<ng-container *ngIf="(isMobile$ | async) else desktop">
  <fm-side-panel-small class="overlay-side-panel"
    *ngIf="isSidePanelOpened$ | async"
    [attr.a7s-id]="'side-panel-content-' + (this.sidePanelContent$ | async)"
    [isSidePanelOpened]="isSidePanelOpened$ | async"
    (closePanel)="hideSidePanel()">
  </fm-side-panel-small>
</ng-container>

<ng-template #desktop>
  <fm-side-panel-large class="overlay-side-panel"
    *ngIf="isSidePanelOpened$ | async"
    [attr.a7s-id]="'side-panel-content-' + (this.sidePanelContent$ | async)"
    [isSidePanelOpened]="isSidePanelOpened$ | async"
    (closePanel)="hideSidePanel()">
    <ng-content></ng-content>
  </fm-side-panel-large>
</ng-template>